import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import AquariumItemManager from '../aquarium/AquariumItemManager';
import ItemSelector from '../aquarium/ItemSelector';
import MessageGuy from '../game/MessageGuy';
import { stopBubbles } from './Background';

export default class AquariumScreen extends Phaser.Scene {
  static get KEY() { return 'AquariumScreen'; }

  constructor() {
    super({ key: AquariumScreen.KEY });
  }

  init() {
    this.itemMenu = null;
    this.aquariumManager = null;
  }

  create() {
    stopBubbles();

    this.aquariumManager = new AquariumItemManager(this);

    this.itemMenu = new ItemSelector(this, this.aquariumManager);

    this.messageGuy = new MessageGuy(this);
    this.messageGuy.setInteractive(this.messageGuy.character.getBounds(), Phaser.Geom.Rectangle.Contains);

    this.messageGuy.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.clamClick, this);
    this.add.existing(this.messageGuy);

    this.add.existing(this.itemMenu);
    this.add.existing(this.aquariumManager);

    this.layoutRatio();

    this.messageGuy.showMessage(ABCyaPhaser.Localization.instance.getLocalizedString('bonus_instructions.drop'), 20, false, 3200);
    this.time.delayedCall(4500, this.showClamClickMessage, null, this);
    const loc = ABCyaPhaser.GameObjects.getScreenPosition(this.messageGuy.character);
    const w = this.messageGuy.character.getBounds().width;
    const h = this.messageGuy.character.getBounds().height;
    const dRect = new Phaser.Geom.Rectangle(loc.x, loc.y, w, h);
    this.aquariumManager.setDeleteRects([dRect]);

    this.input.on(Phaser.Input.Events.GAME_OUT, (time, event) => {
      if (event instanceof MouseEvent) {
        this.input.manager.onMouseUp(event);
      }
    });
  }

  clamClick () {
    this.aquariumManager.doRoaming();
  }

  layoutRatio () {
    this.messageGuy.x = this.scale.width - this.messageGuy.getBounds().width - 20;
    this.messageGuy.y = this.scale.height - this.messageGuy.getBounds().height - 15;

    this.itemMenu.x = 100;
    this.itemMenu.y = 60;
  }

  showClamClickMessage () {
    this.messageGuy.showMessage(ABCyaPhaser.Localization.instance.getLocalizedString('bonus_instructions.swim'), 20, false, 3200);
    this.time.delayedCall(4500, this.showFishStop, null, this);
  }

  showFishStop () {
    this.messageGuy.showMessage(ABCyaPhaser.Localization.instance.getLocalizedString('bonus_instructions.stop'), 20, false, 3200);
  }

  update(time, delta) {
    this.itemMenu.tick(delta / 1000);
    this.aquariumManager.tick(delta / 1000);
  }
}